import type {ReactElement} from 'react';
import React, {useState} from 'react';
import type {AddItemOptionsProps} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';
import {ADD_ITEM_BAR_POPUP_OFFSET, ADD_ITEM_BAR_TOP_OFFSET} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {AddItemButton} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-button';
import {GA4EventName, GA4EventParamName, GA4EventSources, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {BackgroundDropdownList} from '@Components/poster-editor/components/poster-add-item-bar/components/background-dropdown-list';
import {useAppSelector} from '@/hooks';

export function AddBackgroundDropdownOptions({popupClassName = '', isHidden = false, arrowClasses = ''}: AddItemOptionsProps): ReactElement<any> | null {
  const [isOpened, setIsOpened] = useState(false);
  useAppSelector((state) => {
    return state.posterEditor.isVideo;
  });

  if (isHidden) {
    return null;
  }

  return (
    <Dropdown
      id="toolbar-background"
      key="toolbar-background"
      alignment={ALIGNMENT_TYPE.RIGHT}
      selector={<AddItemButton isSelected={isOpened} text={window.i18next.t('pmwjs_background')} icon="icon-background" />}
      popup={<BackgroundDropdownList />}
      popUpHasCustomHeight
      popupOffset={ADD_ITEM_BAR_POPUP_OFFSET}
      topOffset={ADD_ITEM_BAR_TOP_OFFSET}
      maxHeight={500}
      popUpHasCustomWidth
      useDefaultArrow
      usePortal
      popupClassName={popupClassName}
      arrowClasses={arrowClasses}
      position={DROPDOWN_POSITION.FIXED}
      onOpen={(): void => {
        if (!isOpened) {
          trackPosterBuilderGA4Events(GA4EventName.BACKGROUND_MENU_OPEN, {[GA4EventParamName.SOURCE]: GA4EventSources.LEFT_TOOLBAR});
          setIsOpened(true);
        }
      }}
      onClose={(): void => {
        if (isOpened) {
          setIsOpened(false);
        }
      }}
    />
  );
}
